module.exports = __webpack_public_path__ + "static/media/day_seven.c05a98de.jpg";